export default __webpack_public_path__ + "static/media/Group 3848.a963663b.png";